import React from 'react';
import useCondition from '../../../useCondition';
import Header from '../../Header';
import Footer from '../Footer';
import PropertyField from './PropertyField';
import {HubspotContactCheckboxSearchCondition} from './types';

const HubspotContactFilter = () => {
  const {condition, setCondition} = useCondition();

  const searchConditions: HubspotContactCheckboxSearchCondition[] =
    condition.hubspotContactSearchConditions ?? [];

  const setSearchConditions = (
    hubspotContactSearchConditions: HubspotContactCheckboxSearchCondition[],
  ) => setCondition({hubspotContactSearchConditions});

  return (
    <>
      <Header title="HubSpotコンタクト" />
      <div className="p-6 bg-c-bg flex-1 flex flex-col gap-4 rounded-b overflow-y-scroll">
        <div className="bg-white p-6 rounded flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <div className="text-c-base font-bold">条件項目</div>
            {searchConditions.map((searchCondition, index) => (
              <PropertyField
                key={index}
                searchCondition={searchCondition}
                setSearchCondition={(updated) => {
                  const updatedConditions = [...searchConditions];
                  updatedConditions[index] = updated;
                  setSearchConditions(updatedConditions);
                }}
                onDelete={() => {
                  const updatedConditions = [...searchConditions];
                  updatedConditions.splice(index, 1);
                  setSearchConditions(updatedConditions);
                }}
              />
            ))}
            <button
              className="cursor-pointer w-32 h-8 flex items-center justify-center rounded bg-white border border-c-border text-light"
              onClick={() => setSearchConditions([...searchConditions, {}])}
            >
              + 条件を追加
            </button>
          </div>
        </div>
      </div>
      <Footer onClear={() => setSearchConditions([])} />
    </>
  );
};

export default HubspotContactFilter;
